import { environment } from '@environments/environment';

import { ErrorHandler, NgModule } from '@angular/core';

import { LoggerErrorHandlerService } from './logger-error-handler.service';

@NgModule({
  providers:
    environment.production || environment.sentryDsn
      ? [{ provide: ErrorHandler, useClass: LoggerErrorHandlerService }]
      : [],
})
export class LoggerModule {}
